import { bool, object } from 'yup';

import { createCommonSchema } from '@/validation';

const contactConsultant = ({ phone, message, ...initialValues }, errorMessages) =>
  object().shape({
    ...createCommonSchema(initialValues)?.(errorMessages.required),
    acceptContact: bool().oneOf([true], errorMessages.acceptPrivacy),
  });

export default contactConsultant;
